import Vue from 'vue'
import {ptracGetEntities, ptracPost} from 'src/utilities/ptracApi'
import {make} from 'vuex-pathify'
import {OK} from 'http-status-codes'
import {flexmonsterIndexName, objectBy} from 'src/utilities/utils'
import Constants from 'src/utilities/constants'

const initialMapping = {
  jobActualCompletionDate: {
    type: 'date',
    uniqueName: 'jobActualCompletionDate',
    caption: "Job Actual Completion Date"
  },
  jobBuilder: {
    type: 'string',
    uniqueName: 'jobBuilder',
    caption: "Job Builder"
  },
  jobBuilderContact: {
    type: 'string',
    uniqueName: 'jobBuilderContact',
    caption: "Job Builder Contact"
  },
  jobClient: {
    type: 'string',
    uniqueName: 'jobClient',
    caption: "Job Client"
  },
  jobClientContact: {
    type: 'string',
    uniqueName: 'jobClientContact',
    caption: "Job Client Contact"
  },
  jobCommunity: {
    type: 'string',
    uniqueName: 'jobCommunity',
    caption: "Job Community"
  },
  jobCoordinator: {
    type: 'string',
    uniqueName: 'jobCoordinator',
    caption: "Job Coordinator"
  },
  jobCreatedAt: {
    type: 'date',
    uniqueName: 'jobCreatedAt',
    caption: "Job Created At"
  },
  jobCreatedBy: {
    type: 'string',
    uniqueName: 'jobCreatedBy',
    caption: "Job Created By"
  },
  jobDateReceived: {
    type: 'date',
    uniqueName: 'jobDateReceived',
    caption: "Job Date Received"
  },
  jobDepartment: {
    type: 'string',
    uniqueName: 'jobDepartment',
    caption: "Job Department"
  },
  jobName: {
    type: 'string',
    uniqueName: 'jobName',
    caption: "Job Name"
  },
  jobInvoiceBy: {
    type: 'string',
    uniqueName: 'jobInvoiceBy',
    caption: "Job Invoice By"
  },
  jobNumber: {
    type: 'string',
    uniqueName: 'jobNumber',
    caption: "Job Number"
  },
  jobPermitNumber: {
    type: 'string',
    uniqueName: 'jobPermitNumber',
    caption: "Job Permit Number"
  },
  jobPlanName: {
    type: 'string',
    uniqueName: 'jobPlanName',
    caption: "Job Plan Name"
  },
  jobPriority: {
    type: 'string',
    uniqueName: 'jobPriority',
    caption: "Job Priority"
  },
  jobStatus: {
    type: 'string',
    uniqueName: 'jobStatus',
    caption: "Job Status"
  },
  jobTargetCompletionDate: {
    type: 'date',
    uniqueName: 'jobTargetCompletionDate',
    caption: "Job Target Completion Date"
  },
  jobUpdatedAt: {
    type: 'date',
    uniqueName: 'jobUpdatedAt',
    caption: "Job Updated At"
  },
  jobUpdatedBy: {
    type: 'string',
    uniqueName: 'jobUpdatedBy',
    caption: "Job Updated By"
  },
  projectAddressBlockNumber: {
    type: 'string',
    uniqueName: 'projectAddressBlockNumber',
    caption: "Project Address Block Number"
  },
  projectAddressBuildingNumber: {
    type: 'string',
    uniqueName: 'projectAddressBuildingNumber',
    caption: "Project Address Building Number"
  },
  projectAddressCity: {
    type: 'string',
    uniqueName: 'projectAddressCity',
    caption: "Project Address City"
  },
  projectAddressCounty: {
    type: 'string',
    uniqueName: 'projectAddressCounty',
    caption: "Project Address County"
  },
  projectAddressFloorNumber: {
    type: 'string',
    uniqueName: 'projectAddressFloorNumber',
    caption: "Project Address Floor Number"
  },
  projectAddressJurisdiction: {
    type: 'string',
    uniqueName: 'projectAddressJurisdiction',
    caption: "Project Address Jurisdiction"
  },
  projectAddressLegalDescription: {
    type: 'string',
    uniqueName: 'projectAddressLegalDescription',
    caption: "Project Address Legal Description"
  },
  projectAddressLegalSubdivision: {
    type: 'string',
    uniqueName: 'projectAddressLegalSubdivision',
    caption: "Project Address Legal Subdivision"
  },
  projectAddressLotNumber: {
    type: 'string',
    uniqueName: 'projectAddressLotNumber',
    caption: "Project Lot Number"
  },
  projectAddressPhase: {
    type: 'string',
    uniqueName: 'projectAddressPhase',
    caption: "Project Address Phase"
  },
  projectAddressSection: {
    type: 'string',
    uniqueName: 'projectAddressSection',
    caption: "Project Address Section"
  },
  projectAddressState: {
    type: 'string',
    uniqueName: 'projectAddressState',
    caption: "Project Address State"
  },
  projectAddressStreetNumber: {
    type: 'string',
    uniqueName: 'projectAddressStreetNumber',
    caption: "Project Address Street Number"
  },
  projectAddressStreetName: {
    type: 'string',
    uniqueName: 'projectAddressStreetName',
    caption: "Project Address Street Name"
  },
  projectAddressSuiteNumber: {
    type: 'string',
    uniqueName: 'projectAddressSuiteNumber',
    caption: "Project Address Suite Number"
  },
  projectAddressZip: {
    type: 'string',
    uniqueName: 'projectAddressZip',
    caption: "Project Address Zip"
  },
  projectCreatedAt: {
    type: 'date',
    uniqueName: 'projectCreatedAt',
    caption: "Project Created At"
  },
  projectCreatedBy: {
    type: 'string',
    uniqueName: 'projectCreatedBy',
    caption: "Project Created By"
  },
  projectName: {
    type: 'string',
    uniqueName: 'projectName',
    caption: "Project Name"
  },
  projectServiceArea: {
    type: 'string',
    uniqueName: 'projectServiceArea',
    caption: "Project Service Area"
  },
  projectType: {
    type: 'string',
    uniqueName: 'projectType',
    caption: "Project Type"
  },
  projectUpdatedAt: {
    type: 'date',
    uniqueName: 'projectUpdatedAt',
    caption: "Project Updated At"
  },
  projectUpdatedBy: {
    type: 'string',
    uniqueName: 'projectUpdatedBy',
    caption: "Project Updated By"
  },
  taskAssignee: {
    type: 'string',
    uniqueName: 'taskAssignee',
    caption: "Task Assignee"
  },
  taskCompletionDate: {
    type: 'date',
    uniqueName: 'taskCompletionDate',
    caption: "Task Completion Date"
  },
  taskCreatedAt: {
    type: 'date',
    uniqueName: 'taskCreatedAt',
    caption: "Task Created At"
  },
  taskCreatedBy: {
    type: 'string',
    uniqueName: 'taskCreatedBy',
    caption: "Task Created By"
  },
  taskDueDate: {
    type: 'date',
    uniqueName: 'taskDueDate',
    caption: "Task Due Date"
  },
  taskName: {
    type: 'string',
    uniqueName: 'taskName',
    caption: "Task Name"
  },
  taskOwner: {
    type: 'string',
    uniqueName: 'taskOwner',
    caption: "Task Owner"
  },
  taskPriority: {
    type: 'string',
    uniqueName: 'taskPriority',
    caption: "Task Priority"
  },
  taskStatus: {
    type: 'string',
    uniqueName: 'taskStatus',
    caption: "Task Status"
  },
  taskUpdatedAt: {
    type: 'date',
    uniqueName: 'taskUpdatedAt',
    caption: "Task Updated At"
  },
  taskUpdatedBy: {
    type: 'string',
    uniqueName: 'taskUpdatedBy',
    caption: "Task Updated By"
  }
}

const initialState = {
  indexName: null,
  allTaskFields: [],
  query: {
    dateRange: [],
    selectedTaskFields: []
  },
  mapping: JSON.parse(JSON.stringify(initialMapping))
}

const getMappingProp = (fieldLabel) => {
  return 'task' + fieldLabel.replaceAll(' ', '')
}

const state = Vue.util.extend({}, initialState)
const getters = make.getters(state)

getters.requestHeaders = () => {
  const tokenStorage = JSON.parse(localStorage.getItem('okta-token-storage'))
  let headers = null

  if (Constants.ENVIRONMENTS.DEVELOPMENT !== process.env.NODE_ENV) {
    headers = {
      'Authorization': 'Bearer ' + tokenStorage.accessToken.accessToken
    }
  }
  return headers
}

const mutations = make.mutations(state)
mutations.addToMapping = (state) => {
  for (const selectedTaskField of state.query.selectedTaskFields) {
    const field = objectBy(state.allTaskFields, 'key', selectedTaskField.key)
    if (field) {
      const uniqueName = getMappingProp(selectedTaskField.label)
      state.mapping[uniqueName] = {
        type: 'string', // TODO - determine programmatically: string, number, date
        uniqueName,
        caption: 'Task ' + field.label
      }
    }
  }
}
mutations.generateIndexName = (state, user) => {
  state.indexName = flexmonsterIndexName(user.claims.name)
}
mutations.resetMapping = (state) => {
  state.mapping = JSON.parse(JSON.stringify(initialMapping))
}
mutations.resetQuery = (state) => {
  state.query.dateRange = []
  state.query.selectedTaskFields = []
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchAllTaskFields({state}) {
      const response = await ptracGetEntities('task-templates/fields/findUnique')

      if (OK === response.status) {
        state.allTaskFields = response.data
      }

      return response
    },
    async generateReportData({state}) {
      localStorage.setItem(Constants.FLEXMONSTER.LOCAL_STORAGE_KEY, state.indexName)
      const taskFields = state.query.selectedTaskFields.map(field => field.key)
      return await ptracPost('flexmonster/index', {
        indexName: state.indexName,
        startDate: state.query.dateRange[0],
        endDate: state.query.dateRange[1],
        taskFields: taskFields
      })
    }
  }
}
